import { render } from "./SiteSearch.vue?vue&type=template&id=f8a2ae12"
import script from "./SiteSearch.vue?vue&type=script&lang=js"
export * from "./SiteSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/SiteSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8a2ae12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8a2ae12', __exports__)) {
    api.reload('f8a2ae12', __exports__)
  }
  
  module.hot.accept("./SiteSearch.vue?vue&type=template&id=f8a2ae12", () => {
    api.rerender('f8a2ae12', render)
  })

}


export default __exports__